import {useRouter} from 'next/router';
import {useState} from 'react';
import {HOME} from '../../config/constants/routes';
import {
  useGetPopupMessage,
  usePutPopupMessage,
} from '../../core/repositories/usersMeRepository';
import {useAuth} from '../../core/usecases/auth/AuthContext';
import {useMediaQuery} from './useMediaQuery';

export const useHandlePromoPopup = () => {
  const {user: userData, status} = useAuth();
  const {data, isLoading} = useGetPopupMessage({
    config: {enabled: status === 'authenticated'},
  });
  const [isOpen, setIsOpen] = useState(true);
  const savePopup = usePutPopupMessage({
    onSuccessFnc() {
      setIsOpen(false);
    },
    onErrorFnc(_: unknown) {
      setIsOpen(false);
    },
  });
  const closePopup = (messageType: string) => {
    savePopup.mutate(messageType);
  };

  const {isPC} = useMediaQuery();
  const router = useRouter();

  const isSpecificPage =
    router.asPath === HOME ||
    router.asPath === '/following/company' ||
    router.asPath.startsWith('/recruiting_info/view/');
  const isShow = isPC || isSpecificPage;

  return {
    data,
    user: userData ? userData : undefined,
    isOpen,
    isLoading,
    closePopup,
    isShow,
  };
};
